import React, {useEffect, useState} from "react";
import {Button, Col, Modal, notification, Row} from "antd";
import InputField from "../../input-field";
import SelectField from "../../select-field";
import {companyService} from "../../../services";
import i18n from "i18next";

const ROLE_COMPANY_PERSON = 'company_person';
const ROLE_VICE_CARRIER_DIRECTOR = 'vice_carrier_director';

const ROLE_VALUES = [
  { Id: ROLE_COMPANY_PERSON, Name: 'Сотрудник компании' },
  { Id: ROLE_VICE_CARRIER_DIRECTOR, Name: 'Зам. директора' },
];

export default function ModalEditEmployee({isShow, onCloseModal, employee}) {
  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [oldPhone, setOldPhone] = useState(employee.phone);
  const [oldPhoneCode, setOldPhoneCode] = useState(null);
  const [newPhone, setNewPhone] = useState(null);
  const [newPhoneCode, setNewPhoneCode] = useState(null);
  const [firstName, setFirstName] = useState(employee.firstName);
  const [secondName, setSecondName] = useState(employee.secondName);
  const [role, setRole] = useState(employee.role || ROLE_COMPANY_PERSON);
  const [codeFieldVisible, setCodeFieldVisible] = useState(false);
  const [tokensData, setTokensData] = useState(null);

  let editNumberButton = {
    height: '43px',
    background: '#2b3f63',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent",
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  };
  let blueButton = {
    width: '200px',
    height: '43px',
    background: '#2b3f63',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent",
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  };
  let activeButton = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent",
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  };
  let redButton = {
    width: '200px',
    height: '43px',
    background: 'red',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent",
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  };

  useEffect(() => {
    if (isShow && !loadingContentModal) {
      setLoadingContentModal(true);
    }
  }, [isShow]);

  const getFieldErrors = (nameField) => {
    return fieldsErrors && typeof fieldsErrors[nameField] !== "undefined" ? fieldsErrors[nameField][0] : null;
  };

  const handleRecieveCodes = (e) => {
    companyService
      .getSmsVerification({employeeId: employee.id, newPhone})
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.getSmsVerification'),
            description: data.message,
          });
        } else {
          setCodeFieldVisible(true);
          setTokensData(data);
        }
        if (data.errors) {
          setFieldsErrors(data.errors);
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.getSmsVerification'),
          description: error,
        });
      });
  };

  const handleSendCodes = (e) => {
    companyService
      .sendCodes({
        employeeId: employee.id,
        oldPhoneToken: tokensData.oldPhoneToken,
        oldPhoneCode,
        newPhoneToken: tokensData.newPhoneToken,
        newPhoneCode,
        newPhone,
      })
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.sendCodes'),
            description: data.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.sendCodes'),
            description: data.message,
          });
          onCloseModal();
        }
        if (data.errors) {
          setFieldsErrors(data.errors);
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.sendCodes'),
          description: error,
        });
      });
  };

  const handleChangeName = (e) => {
    companyService
      .changeEmployeeName({
        employeeId: employee.id,
        firstName,
        secondName,
        role,
      })
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.changeEmployeeName'),
            description: data.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.changeEmployeeName'),
            description: data.message,
          });
          onCloseModal();
        }

        if (data.errors) {
          setFieldsErrors(data.errors);
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.changeEmployeeName'),
          description: error,
        });
      });
  };

  const handleBlockEmployee = (e) => {
    companyService
      .blockEmployee({
        employeeId: employee.id,
      })
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.blockEmployee'),
            description: data.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.blockEmployee'),
            description: data.message,
          });
          onCloseModal();
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.blockEmployee'),
          description: error,
        });
      });
  };

  const handleUnblockEmployee = (e) => {
    companyService
      .unblockEmployee({
        employeeId: employee.id,
      })
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.unblockEmployee'),
            description: data.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.unblockEmployee'),
            description: data.message,
          });
          onCloseModal();
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.unblockEmployee'),
          description: error,
        });
      });
  };

  const handleArchiveEmployee = (e) => {
    companyService
      .archiveEmployee({
        employeeId: employee.id,
      })
      .then((data) => {
        if (data.status === "error") {
          notification.error({
            message: i18n.t('components.notification.titles.archiveEmployee'),
            description: data.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.archiveEmployee'),
            description: data.message,
          });
          onCloseModal();
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.archiveEmployee'),
          description: error,
        });
      });
  };

  return (
    <Modal
      title={employee.name}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={onCloseModal}
      footer={[
        <Button style={blueButton} htmlType="submit" key="archieve" type="primary" onClick={handleArchiveEmployee}>
          {i18n.t('modals.modalEditEmployee.buttons.archive')}
        </Button>,
        employee.status === "Активен" ? (
          <Button style={redButton} htmlType="submit" key="block" type="primary" onClick={handleBlockEmployee}>
            {i18n.t('modals.modalEditEmployee.buttons.block')}
          </Button>
        ) : (
          <Button style={activeButton} htmlType="submit" key="block" type="primary" onClick={handleUnblockEmployee}>
            {i18n.t('modals.modalEditEmployee.buttons.unblock')}
          </Button>
        ),
      ]}
    >
      <Row gutter={[12, 12]}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <InputField
            name="oldPhone"
            mask="+7(111)111-11-11"
            label={i18n.t('modals.modalEditEmployee.fields.oldPhone.title')}
            value={oldPhone}
            setValue={setOldPhone}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col>
          {codeFieldVisible ? (
            <InputField name="oldPhoneCode" label={i18n.t('modals.modalEditEmployee.fields.oldPhoneCode.title')} value={oldPhoneCode} setValue={setOldPhoneCode}
                        getFieldErrors={getFieldErrors}/>
          ) : null}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <InputField
            name="newPhone"
            mask="+7(111)111-11-11"
            label={i18n.t('modals.modalEditEmployee.fields.newPhone.title')}
            value={newPhone}
            setValue={setNewPhone}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col>
          {codeFieldVisible ? (
            <InputField name="newPhoneCode" label={i18n.t('modals.modalEditEmployee.fields.newPhoneCode.title')} value={newPhoneCode} setValue={setNewPhoneCode}
                        getFieldErrors={getFieldErrors}/>
          ) : null}
        </Col>
        <Col lg={12} md={24} sm={24} xs={24} style={{marginTop: '15px', marginBottom: '15px'}}>
          <Button
            style={editNumberButton}
            htmlType="submit"
            type="primary"
            onClick={handleRecieveCodes}
            key="get-codes"
          >
            {i18n.t('modals.modalEditEmployee.buttons.getCodes')}
          </Button>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24} style={{marginTop: '15px', marginBottom: '15px'}}>
          <Button style={activeButton} htmlType="submit" type="primary" key="change-number" onClick={handleSendCodes}>
            {i18n.t('modals.modalEditEmployee.buttons.changeNumber')}
          </Button>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <InputField name="firstName" label={i18n.t('modals.modalEditEmployee.fields.firstName.title')} value={firstName} setValue={setFirstName}
                      getFieldErrors={getFieldErrors}/>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <InputField name="secondName" label={i18n.t('modals.modalEditEmployee.fields.secondName.title')} value={secondName} setValue={setSecondName}
                      getFieldErrors={getFieldErrors}/>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <SelectField
            title={i18n.t('modals.modalCreateEmployee.fields.role.title')}
            name="role"
            selectedValue={role}
            values={ROLE_VALUES}
            onChange={value => setRole(value)}
            getErrors={getFieldErrors}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} style={{marginTop: '15px', marginBottom: '15px'}}>
          <Button style={activeButton} htmlType="submit" key="submit" type="primary" onClick={handleChangeName}>
            {i18n.t('main.buttons.save')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}
